"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Setup = exports.nX = exports.DisplayNodes = void 0;
const helpers_1 = require("../helpers");
var DisplayNodes;
var nX;
function Setup(selectors) {
    exports.DisplayNodes = DisplayNodes = (0, helpers_1.getDomNodes)(selectors);
    exports.nX = nX = DisplayNodes["nX"] || document.getElementById("nX");
    const pp_btn = document.getElementById("playpause_btn");
    const ppEvent = new Event("playpause");
    pp_btn.onclick = (event) => {
        window.dispatchEvent(ppEvent);
    };
}
exports.Setup = Setup;
